<script>
  import { ULink } from "../../../core";
  import UPicture from "../../../core/u-elements/UPicture.svelte";
  import type { ISpotItem } from "./Spot.svelte";

  export let item: ISpotItem;
</script>

<div class="item">
  <ULink data={item.link} aria-label={item.link?.name}>
    <UPicture data={item.image} />
  </ULink>

  <div class="info">
    {#if item.date}
      <div class="date">{item.date}</div>
    {/if}

    {#if item.link}
      <ULink data={item.link}>
        <div class="title">{item.title}</div>
      </ULink>
    {:else}
      <div class="title">{item.title}</div>
    {/if}

    <div class="desc rte">
      {@html item.description || ""}
    </div>

    <div class="spot-link">
      <ULink class="link" data={item.link} />
    </div>
  </div>
</div>

<style lang="scss">
  .item {
    .info {
      padding: 20px 0;
      @include small;
    }

    .title {
      @include h2;
      margin-bottom: 10px;
    }

    .desc {
      margin-bottom: 5px;

      :global(p),
      :global(h1),
      :global(h2),
      :global(ul),
      :global(ol),
      :global(li) {
        @include small;
        margin-bottom: 8px !important;
      }
    }

    :global(img) {
      width: 100%;
    }
  }
</style>
